import { useState } from 'react';
import Button from '../UI/Button';
import styles from './TodoForm.module.css';

function TodoForm({ addTodo }) {
  const [text, setText] = useState('');

  function onSubmitHendler(event) {
    event.preventDefault();
    addTodo(text);
    setText('');
  }
  return (
    <div className="">
      <form onSubmit={onSubmitHendler}>
        <label>
          <input
            className={styles.todoForm}
            placeholder="Enter new todo"
            value={text}
            onChange={(e) => {
              setText(e.target.value);
            }}
          />
        </label>

        <Button type="submit" title="Submit">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default TodoForm;
